import { useEffect } from 'react';
import { Table } from '@tanstack/react-table';
import { PaginatedData } from 'types/pagination';

const useSyncPaginatedData = <T,>(table: Table<T>, data?: PaginatedData<T>) => {
    const dataLen = data?.data.length;
    const currentPage = data?.meta.current_page ?? 0;
    const lastPage = data?.meta.last_page ?? 0;
    const diff = Math.abs(currentPage - lastPage);
    const pageIndex = diff > 1 ? 0 : lastPage - 1;

    useEffect(() => {
        if (dataLen === 0 && currentPage > 1 && table.options.manualPagination) {
            table.setPagination(p => ({ ...p, pageIndex }));
        }
    }, [dataLen, currentPage, pageIndex, table]);
};

export { useSyncPaginatedData };
